import React, { useState, useEffect, useRef } from 'react';
import './UsernameModal.css';

function UsernameModal({ isEditing, currentUsername, onSave, onClose }) {
  const [inputValue, setInputValue] = useState(currentUsername);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = () => {
    const name = inputValue.trim();
    if (name.length < 2) {
      alert('Username must be at least 2 characters');
      return;
    }
    onSave(name);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="modal-overlay" onClick={isEditing ? onClose : undefined}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            {isEditing ? 'Change Username' : 'Welcome to SyncPlay! 👋'}
          </h2>
          {isEditing && (
            <button className="modal-close" onClick={onClose}>✕</button>
          )}
        </div>
        
        <p className="modal-description">
          {isEditing 
            ? 'Enter a new username to continue' 
            : 'Please enter a username to get started'
          }
        </p>
        
        <div className="modal-input-group">
          <input
            ref={inputRef}
            type="text"
            className="modal-input"
            placeholder="Enter your username..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            minLength={2}
            maxLength={30}
          />
          <button className="btn btn-primary modal-save-btn" onClick={handleSubmit}>
            {isEditing ? 'Update' : "Let's Go!"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UsernameModal;